// atoms/validState.js
import { atom } from 'recoil';

export const validState = atom({
  key: 'validState', // unique ID (with respect to other atoms/selectors)
  default: true,     // default value
});
